<template>
  <div
    class="mt-4"
    :style="`min-height:${innerHeight < 768 ? 768 : innerHeight}px`"
  >
    <div v-if="!isUpdateMode && !isDeleteMode">
      <strong>
        <a class="btn btn-default btn-sm" @click="createCust()">
          <div class="d-flex align-items-center">
            <i class="icon-add_new text-orange i-18"></i>
            新增客戶
          </div>
        </a>
      </strong>
      <strong>
       <a class="btn btn-default btn-sm float-right" @click="changeUpdateMode"> 
          <i class="icon-edit i-18"></i>
          編輯家戶
        </a>
      </strong>
      <strong>
       <a class="btn btn-default btn-sm float-right" @click="changeDeleteMode"> 
          <i class="icon-trashcan i-18"></i>
          刪除客戶
        </a>
      </strong>
    </div>
    <div class="mt-21 d-inline-flex" v-else>
      <a v-if="getAllFamilyResult.length > 1" class="btn btn-red btn-sm" @click="panelOpen('mvDeleteFamilyOpen')"
        >解散家戶</a
      >
      <p v-else  class="btn btn-sm  btn-disabled"> 解散家戶</p>
      <p class="text-red mb-0 mt-2 ml-27">
        *編輯資料後，請點擊頁面右下角的「儲存」按鈕才算完成編輯。
      </p>
    </div>
    <div class="mt-21">
      <div
        class="list"
        v-if="getAllFamilyResult.length != 0"
        style="margin-bottom: 150px"
        ref="countHeight"
      >
        <div
          style="border: #bebebe solid 1px"
          class="rounded-8 col-12 pl-10 mb-2 shadow-sm"
        >
          <tr class="d-flex align-items-center">
            <th class="col-1 d-flex flex-column">
              <div v-if="!isUpdateMode && !isDeleteMode" class="checkbox checkbox-inline mr-0">
                <input
                  v-model="theadAll"
                  @click="changeInput(0, 'Y')"
                  type="checkbox"
                  id="thead"
                />
                <label for="thead">
                  <span>#</span>
                </label>
              </div>
              <div
                class="d-flex align-items-center justify-content-end"
                style="height: 40px"
                v-else
              >
                <span style>#</span>
              </div>
            </th>
            <th class="col-2 d-flex justify-content-left">
              <strong
                :class="
                  !isUpdateMode && !isDeleteMode
                    ? 'fw-600 ml-27 d-flex justify-content-left'
                    : ''
                "
              >
                姓名
                <span v-if="isUpdateMode || isDeleteMode" class="requireSpan">
                  <span class="star">*</span>
                  必填
                </span>
              </strong>
            </th>
            <th v-if="isUpdateMode || isDeleteMode" class="col-1 d-flex flex-column">
              <strong class="fw-600 w-left">
                性別

                <span class="requireSpan">
                  <span class="star">*</span>
                  必填
                </span>
              </strong>
            </th>
            <th
              class="d-flex justify-content-left"
              :class="isUpdateMode || isDeleteMode? `col-2` : 'col-1'"
            >
              <strong class="fw-600">
                身份
                <span v-if="isUpdateMode || isDeleteMode" class="requireSpan">
                  <span class="star">*</span>
                  必填
                </span>
              </strong>
            </th>
            <th class="col-2 d-flex justify-content-left">
              <strong
                :class="
                  !isUpdateMode && !isDeleteMode ? 'fw-600 d-flex justify-content-left' : ''
                "
                >身分證</strong
              >
            </th>
            <th
              class="d-flex flex-column"
              :class="!isUpdateMode && !isDeleteMode ? 'col-2' : 'col-3'"
            >
              <strong
                :class="
                  !isUpdateMode && !isDeleteMode
                    ? 'fw-600 d-flex justify-content-left'
                    : 'w-left'
                "
              >
                生日
                <span v-if="isUpdateMode || isDeleteMode" class="requireSpan">
                  <span class="star">*</span>

                  生日或年齡擇一必填
                </span>
              </strong>
            </th>
            <th class="col-1 d-flex flex-column">
              <strong class="w-left fw-600 ml-1">年齡</strong>
            </th>
            <th v-if="!isUpdateMode && !isDeleteMode" class="col-3 d-flex flex-column">
              <strong
                :class="
                  !isUpdateMode && !isDeleteMode ? 'fw-600 d-flex justify-content-left' : ''
                "
                >提醒</strong
              >
            </th>
          </tr>
        </div>
        <template v-for="(item, i) in getAllFamilyResult">
          <div
            v-if="!item.isRemove && !item.isDelete"
            :key="`group-item-${i}`"
            style="border: #bebebe solid 1px"
            class="rounded-8 col-12 pl-10 pt-2 pb-2 shadow-sm mb-2"
            :class="item.isRemove || item.isDelete ? 'deleted' : ''"
          >
            <tr class="d-flex align-items-center">
              <th class="col-1 d-flex flex-column">
                <div
                  class="d-flex align-items-center justify-content-between"
                  v-if="isUpdateMode"
                >
                  <button
                    type="button"
                    class="btn btn-sm removeButton"
                    :class="item.familyrl == 0 ? 'btn-disabled' : 'btn-red'"
                    style="white-space: nowrap"
                    @click="checkSingleDelete(item)"
                  >
                    移除
                  </button>
                  <div>{{ i + 1 }}</div>
                </div>
                <div
                  class="d-flex align-items-center justify-content-between"
                  v-else-if="isDeleteMode"
                >
                  <button
                    type="button"
                    class="btn btn-sm btn-red removeButton"
                    style="white-space: nowrap"
                    @click="checkSingleDelete(item)"
                  >
                    刪除
                  </button>
                  <div>{{ i + 1 }}</div>
                </div>
                <div v-else class="checkbox checkbox-inline mr-0 block-heigh">
                  <input
                    style
                    :id="`customer-${i}`"
                    :value="item.csidno"
                    type="checkbox"
                    v-model="getAllFamilyResult[i]['check']"
                    @click="changeInput(i, 'N')"
                  />
                  <label :for="`customer-${i}`">
                    <span>{{ i + 1 }}</span>
                  </label>
                </div>
              </th>
              <th class="col-2 d-flex flex-column pl-1">
                <div v-if="isUpdateMode || isDeleteMode">
                  <input
                    :name="`name-${i}`"
                    v-validate="'required'"
                    :class="{ 'is-invalid': errors.has(`name-${i}`) }"
                    :disabled="(item.isRemove || item.isDelete) || !$checkEdit(UserInfo)"
                    class="form-control"
                    v-model="item.name"
                    v-policy.name
                    alt="ch"
                    @input="checkInputName(item)"
                    @blur="checkInputName(item)"
                  />
                </div>
                <div
                  class="d-flex align-items-center"
                  v-else
                >
                  <div class="mr-2" style="width: 30px">
                    <div v-if="item.vip_lvl" class="controlAvatarLevel">
                      <level :lv="Number(item.vip_lvl)" />
                    </div>
                    <div>
                      <avatar :gender="Number(item.sex)" :size="20" />
                    </div>
                  </div>
                  <Tooltip
                    :position="item.index < 4 ? 'bottom' : 'top'"
                    :id="item.csidno"
                    :birthday="formatDate(item.birthday)"
                  >
                    <div class="font-20 breakLine text-left">
                      <a>
                        {{ item.name ? item.name : "一 一" }}
                      </a>
                    </div>
                  </Tooltip>
                </div>
              </th>
              <th v-if="isUpdateMode || isDeleteMode" class="col-1 d-flex flex-column">
                <div>
                  <select
                    :disabled="(item.isRemove || item.isDelete) || !$checkEdit(UserInfo)"
                    style="width: 100%"
                    :name="`sex-${i}`"
                    v-validate="'required'"
                    :class="{ 'is-invalid': errors.has(`sex-${i}`) }"
                    class="form-control form-control-inline form-wide"
                    v-model="item.sex"
                  >
                    <option
                      v-for="(type, index) in ['男', '女']"
                      v-bind:value="type == '男' ? '1' : '2'"
                      :key="index"
                    >
                      {{ type }}
                    </option>
                  </select>
                </div>
              </th>
              <th
                class="d-flex flex-column"
                :class="isUpdateMode || isDeleteMode ? `col-2` : 'col-1'"
              >
                <div v-if="isUpdateMode || isDeleteMode">
                  <select
                    :disabled="(getAllFamilyResult.length < 2 && !isDeleteMode) || item.isRemove"
                    :name="`familyrl-${i}`"
                    v-validate="'required'"
                    :class="{ 'is-invalid': errors.has(`familyrl-${i}`) }"
                    class="form-control form-wide"
                    v-model="item.familyrl"
                  >
                    <option
                      v-for="(type, index) in familyRl"
                      v-bind:value="Number(type.role_id)"
                      :key="index"
                    >
                      {{ type.role_name }}
                    </option>
                  </select>
                </div>
                <div class="d-flex justify-content-left" v-else>
                  {{
                    familyRl.filter((el) => el.role_id == item.familyrl)[0]
                      .role_name
                  }}
                </div>
              </th>
              <th class="col-2 d-flex flex-column">
                <div :class="'d-flex justify-content-left'">
                  {{
                    item.csidno.includes("~")
                      ? "一 一"
                      : item.csidno
                      ? item.csidno
                      : "一 一" | getMaskID
                  }}
                </div>
              </th>
              <th
                class="d-flex flex-column"
                :class="!isUpdateMode && !isDeleteMode? 'col-2' : 'col-3'"
              >
                <div v-if="isUpdateMode || isDeleteMode" class="d-flex align-items-center">

                  <BirthdayComponent
                    ref="birthday"
                    :itemData="item.birthdayROC"
                    :showErrText="false"
                    :isBirdayError="isBirdayError[i] ? isBirdayError[i] : false"
                    :validateOpen="
                      (!item.age || String(item.age).trim() === '') &&
                      item.age !== 0
                    "
                    @getTime="getTime($event, item)"
                  />
                </div>
                <div
                  :class="!isUpdateMode && !isDeleteMode ? 'd-flex justify-content-left' : ''"
                  v-else
                >
                  {{
                    item.birthday
                      ? formatDate(item.birthday)
                      : "一 一" | getMaskBirthday
                  }}
                </div>
              </th>
              <th class="col-1 d-flex flex-column">
                <div v-if="isUpdateMode || isDeleteMode" class="d-flex justify-content-between">
                  <input
                    :data-vv-name="`age-${i}`"
                    v-validate="{
                      required:
                        (!item.age || String(item.age).trim() === '') &&
                        item.age !== 0,
                    }"
                    maxlength="3"
                    :class="{ 'is-invalid': errors.has(`age-${i}`) }"
                    class="form-control"
                    v-model="item.age"
                    :disabled="item.birthdayROC || !$checkEdit(UserInfo)"
                    @input="checkInputAge(item)"
                    @blur="checkInputAge(item)"
                  />
                  <span class="align-self-center"></span>
                </div>

                <div v-else class="ml-2 w-left">
                  {{ item.age || item.age === 0 ? item.age : "一 一" }}
                </div>
              </th>
              <th
                v-if="!isUpdateMode && !isDeleteMode"
                class="col-3 d-flex justify-content-left"
              >
                <div class="mr-28 text-left">
                  <div>{{ item.notify }}</div>
                  <template v-if="item.memochk === 'Y'">
                    <span>本客戶尚有房貸拍賣不足餘額未清償</span>
                    (
                    <span
                      class="custGreen btn p-0 m-0"
                      @click="panelOpen('mvInfoOpen')"
                      >說明</span
                    >
                    )
                  </template>
                </div>
              </th>
            </tr>
          </div>
        </template>
        <div
          class="col-md-12"
          style="height: 240px"
          ref="dateDiv"
          v-show="isOpen"
        ></div>
      </div>
      <div v-else class="text-center d-flex justify-content-center" colspan="6">
        <div
          :class="{ 'mt-4 section-loading': custsOfAgntIsLoading }"
          style="height: 20px; width: 30px"
        ></div>
        <h3 class="mb-3">{{ this.remoteDataMessage }}</h3>
      </div>
      <Fixed-Bottom v-show="!isScroll">
        <template slot="@function">
          <div v-if="!isUpdateMode && !isDeleteMode" class="d-flex justify-content-end">
            <button
              @click="rePushMember"
              class="btn btn-default mr-3"
              type="button"
            >
              <i class="fas fa-sync mr-2"></i>
              重新歸戶
            </button>
            <button
              type="button"
              @click="pushPolicyHealthCheck"
              class="btn btn-primary mr-0"
            >
              開始保單健檢
            </button> 
          </div>
          <div v-else class="d-flex justify-content-end">
            <div v-if="isUpdateMode" class="checkDeleteContent">
              {{
                checkRemoveCount
                  ? `提醒：本次儲存後，將移除${checkRemoveCount}位家戶成員`
                  : ""
              }}
            </div>
            <div v-if="isDeleteMode" class="checkDeleteContent">
              {{
                checkDeleteCount
                  ? `提醒：本次儲存後，將刪除${checkDeleteCount}位家戶成員`
                  : ""
              }}
            </div>
            <button
              @click="isDeleteMode ? changeDeleteMode() : changeUpdateMode()"
              class="btn btn-default btn-custStyle mr-3"
              type="button"
            >
              取消
            </button>
            <button
              type="button"
              @click="saveItems"
              class="btn btn-primary btn-custStyle mr-0"
            >
              儲存
            </button>
          </div>
        </template>
      </Fixed-Bottom>
    </div>
    <Mv-Info :open="mvInfoOpen" @close="closeModal()">
      <div class="text" slot="content">
        <div class="font-20 mt-10">
          如備註有【本客戶尚有房貸拍賣不足餘額未清償】時，請提醒客戶公司可依法抵銷其保險金債權。如有相關問題請洽
          <span class="custGreenBold">債權管理科</span>
          。(資料每月更新乙次，更新日為每月六號)
        </div>
      </div>
    </Mv-Info>
    <Mv-Info 
      :open="deleteHolderMvInfoOpen" 
      @close="closeDeleteHolderMvInfoModal">
      <div class="text mb-5 font-cust" slot="content">
        <div>
          原家戶戶長
          <span class="text-green">{{ familyData.name }}</span>
          已刪除，  
          <span class="text-red">
            需從原家戶剩下的家戶成員中，指定一位新戶長。
          </span>
        </div>
      </div>
    </Mv-Info>

    <Mv-Delete
      :open="mvDeleteOpen"
      @close="closeMvDeleteModal()"
      @confirm="sendUpdate()"
    >
      <div class="text" slot="content">
        <div>
          本次編輯有「刪除家戶成員」，刪除後需重新歸戶，請再次確認
        </div>
      </div>
    </Mv-Delete>
    <Mv-Delete-Single
      v-if="isUpdateMode"
      :open="mvDeleteSingleOpen"
      @close="closeMvSingleDeleteModal()"
      @confirm="closeMvSingleDeleteModal('R')"
    >
      <div class="text font-cust" slot="content">
        <div>
          您要移除家戶成員
          <span class="text-green">{{ confirmDeleteItem.name }}</span>
          嗎？若移除家戶成員，該成員將自成一戶
        </div>
      </div>
    </Mv-Delete-Single>
    <Mv-Delete-Single
      v-if="isDeleteMode"
      :open="mvDeleteSingleOpen"
      @close="closeMvSingleDeleteModal()"
      @confirm="confirmDeleteHolder"
    >
      <div class="text font-cust" slot="content">
        <div>
          您要刪除家戶成員
          <span class="text-green">{{ confirmDeleteItem.name }}</span>
          嗎？確認刪除後資料將無法回復，請確認是否刪除?
        </div>
      </div>
    </Mv-Delete-Single>

    <Warning-Modal
    :open="WarningDoubleCheckModalOpen"
    :message="WarningDoubleCheckModalMessage"
    :confirmText="`確認刪除`"
    @close="panelClose('WarningDoubleCheckModalOpen')"
    @submit="closeWarningDoubleCheckModal"/>

    <Mv-Delete-Family
      v-if="isUpdateMode"
      :isFinalDelete="checkDeleteFamilyModal"
      :open="mvDeleteFamilyOpen"
      @close="closeMvFamilyDeleteModal()"
      @confirm="closeMvFamilyDeleteModal('O')"
    >
      <div class="text mb-5 font-cust" slot="content">
        <div v-if="!checkDeleteFamilyModal">
          您要解散以
          <span class="text-green">{{ familyData.name }}</span>
          為戶長的家戶嗎？若解散家戶，所有成員將各自獨立一戶。
        </div>
        <div v-else>
          此家戶將被解散，所有成員將各自成為獨立家戶。確定要解散此家戶嗎?
        </div>
      </div>
    </Mv-Delete-Family>

    <Mv-Delete-Family
      v-if="isDeleteMode"
      :open="mvDeleteFamilyOpen"
      @close="closeMvFamilyDeleteModal()
      closeMvSingleDeleteModal()"
      @confirm="closeMvSingleDeleteModal('D')
      closeMvFamilyDeleteModal()"
    >
      <div class="text mb-5 font-cust" slot="content">
        <div>
          原家戶戶長
          <span class="text-green">{{ familyData.name }}</span>
          已刪除，  
          <span class="text-red">
            確認刪除後，此家戶將被解散。
          </span>
        </div>
      </div>
    </Mv-Delete-Family>

    <Bkmv-Add-Family-Modal
      :open="bkmvAddFamilyOpen"
      :csidno="familyData.csidno"
      @close="panelClose('bkmvAddFamilyOpen')"
      @confirm="panelOpen('bkmvAddFamilyOpen')"
    />
    <Mv-Birth-Check
      :open="mvPolicyAndCustomerBirthCheckOpen"
      :diffData="diffBirthPolicies"
      @close="panelClose('mvPolicyAndCustomerBirthCheckOpen')"
      @confirm="confirmPolicyHealthCheck"
    />

    <!-- 打開遮罩 -->
    <Mv-Mask :open="mvMaskOpen" :content="maskContent" />
    <Check-Company-Colleague-Prop
      :open="showCheckCompanyColleague"
      :memberName="companyColleagueList"
      @close="panelClose('showCheckCompanyColleague')"
    >
    </Check-Company-Colleague-Prop>

    <Leave-Page-Warning-Modal
      :open="leavePageWarningModalOpen"
      ref="leavePageWarningModal"
      message="編輯資料尚未儲存，請問是否繼續編輯？<br>若要儲存編輯資料請留在本頁面並點擊畫面右下角的「儲存」按鈕"
      cancelText="離開"
      submitText="是"
      @submit="panelClose('leavePageWarningModalOpen')"
      @close="panelClose('leavePageWarningModalOpen')"
    >
    </Leave-Page-Warning-Modal>
    <Legal-Warning-Modal
          :open="createCustWarningOpen"
          :message="warningMessage"
          :showCancel="false"
          @submit="proceedToCreate"
          @close="panelClose('createCustWarningOpen')"
        />   
  </div>
</template>

<script>
import moment from "moment";
import Avatar from "@/desktop/views/mv/components/Avatar";
import { mapActions, mapGetters } from "vuex";
import { commonMixin } from "@/mixins/common";
import MvInfo from "@/desktop/views/mv/components/mvInfo";
import MvDelete from "@/desktop/views/mv/components/mvDelete";
import MvDeleteSingle from "@/desktop/views/mv/components/mvDelete";
import MvDeleteFamily from "@/desktop/views/mv/components/mvDelete";
import BkmvAddFamilyModal from "@/desktop/views/bkmv/components/bkmvAddFamilyModal";
import LeavePageWarningModal from "@/desktop/views/mv/components/leavePageWarningModal";
import MvBirthCheck from "@/desktop/views/bkmv/components/bkPolicyAndCustomerBirthCheck";
import Level from "@/desktop/views/mv/components/Level";
import { getFamilyrl } from "@/service/modules/mvCommon";
import BirthdayComponent from "@/desktop/components/form/BirthdayComponent";
import FixedBottom from "@/desktop/views/mv/components/modal/fixedBotton";
import WarningModal from '@/desktop/components/WarningModal'

import {
  getAllHouseholderBySales,
  getAllFamily,
  modifyFamilyMember_BNK,
  checkPolicyExist,
  isCustomerAgreeRemind,
  deleteFamily,
  getOtherPropertyInsurance,
  getCustInsurance_CCIPLN4MV,
  getCustInsurance_CCIPLN2MV,
  getCustInsurance_CCIPLN1MV,
  getCustInsurance_CCIPLC1MV,
  getCustInsurance_CCIPLF1MV,
  checkBirthDayDifferent,
  differBirthDayLog,
  checkCompanyColleague,  
} from "@/service";
import MvMask from "@/desktop/views/mv/components/mvMask";
import HardwordMixins from "@/mixins/Hardword";
import Tooltip from "@/desktop/components/ToolTip";
import CheckCompanyColleagueProp from "@/desktop/views/mv/components/CheckCompanyColleagueProp";
import LegalWarningModal from "@/desktop/components/WarningModal4"; 

export default {
  name: "bkRelation",
  mixins: [commonMixin, HardwordMixins],
  data() {
    return {
      //全選
      theadAll: false,
      //業務員ID
      agidno: this.$store.state.userInfo.id,
      //前頁FAMILY DATA
      familyData: this.$store.state.userItems,
      //過濾有勾選
      familyResultFilter: [],
      //過濾未被勾選
      lastFamilyResultFilter: [],
      //MOUNTED搜尋回傳結果
      getAllFamilyResult: [],
      //是否顯示LOADING
      custsOfAgntIsLoading: false,
      remoteDataMessage: "資料讀取中，請稍候...",
      WarningDoubleCheckModalMessage: "確認刪除後資料將無法回復，請確認是否刪除?",
      //是否要為編輯狀態
      isUpdateMode: false,
      //是否要為刪除狀態
      isDeleteMode: false,
      //儲存更動前狀態
      getAllFamilyResultOriginal: [],
      //生日年
      birthYearOpt: [],
      //生日月
      birthMonthOpt: [],
      //生日日
      birthDayOpt: [],
      //生日日期錯誤檢核
      isBirdayError: [],
      //mvInfo Modal開闔
      mvInfoOpen: false,
      //刪除戶長用mvInfo Modal開闔
      deleteHolderMvInfoOpen : false,
      //刪除戶長用waring Modal開闔
      WarningDoubleCheckModalOpen : false,
      //mvDelete Modal開闔
      mvDeleteOpen: false,
      //mvSingleDelete Modal開闔
      mvDeleteSingleOpen: false,
      //mvDeleteFamily Modal開闔
      mvDeleteFamilyOpen: false,
      //家戶生日與保單生日不同步提醒Modal開關
      mvPolicyAndCustomerBirthCheckOpen: false,
      //即將離開本頁面提醒提醒Modal開關
      leavePageWarningModalOpen: false,
      //是否第一次進入頁面
      isFirst: true,
      //確認刪除名單
      confirmDeleteNameList: [],
      //確認單一刪除成員
      confirmDeleteItem: "",
      //判斷解散家戶Modal是否為第一次彈出
      checkDeleteFamilyModal: false,
      //遮罩
      mvMaskOpen: false,
      //遮罩字樣
      maskContent: "",
      isScroll: false,
      //重新歸戶Modal
      bkmvAddFamilyOpen: false,
      //判斷是否已有配偶
      hasSpouse: false,
      //頁高
      innerHeight: window.innerHeight,
      //身分SELECT使用
      familyRl: [],
      //日曆下拉選單多高度顯示
      isOpen: false,
      //生日不相同的保單資料
      diffBirthPolicies: [],
      //.Net API回傳勾選人員
      familyMember: [],
      // 公司同事檢核 - open flag
      showCheckCompanyColleague: false,
      // 公司同事檢核 - 顯示列表
      companyColleagueList: [],
      //是否為保代用頁面
      isFromBank: true,
      //是否刪除家戶 
      isDeleteFamily:false,
      //受否已無任何家戶成員
      isNoFamilyMember:false,
      //個資法WarningModal
      createCustWarningOpen: false,
      warningMessage: '為確保客戶(準客戶)個人資料權益，請告知以下內容，並確實取得同意，為其進行資料建檔',
      pdpaAgreeTime: "",      
    };
  },
  components: {
    Avatar,
    MvInfo,
    MvBirthCheck,
    MvDelete,
    MvDeleteSingle,
    MvDeleteFamily,
    BkmvAddFamilyModal,
    MvMask,
    FixedBottom,
    Level,
    BirthdayComponent,
    Tooltip,
    CheckCompanyColleagueProp,
    LeavePageWarningModal,
    WarningModal,
    LegalWarningModal,  
  },
  computed: {
    ...mapGetters(["BaseUrl", "UserItems", "UserInfo", "AllFamilyResult"]),
    checkRemoveCount() {
      let count = 0;
      this.getAllFamilyResult.forEach((item) => {
        if (item.isRemove) {
          count++;
        }
      });
      return count;
    },
    checkDeleteCount() {
      let count = 0;
      this.getAllFamilyResult.forEach((item) => {
        if (item.isDelete) {
          count++;
        }
      });
      return count;
    },
  },
  watch: {
    getAllFamilyResult: {
      handler(newValue, oldValue) {
        if (this.isUpdateMode || this.isDeleteMode) {
          newValue = this.getAllFamilyResult.map((item) => {
            if (item.birthdayROC) {
              item.birthday = moment(item.birthdayROC).format("YYYY-MM-DD");
            }
            return item;
          });
        } else {
          //被勾選
          this.familyResultFilter = this.getAllFamilyResult.filter((item) => {
            return item.check == true;
          });
          this.lastFamilyResultFilter = this.getAllFamilyResult.filter(
            (item) => {
              return item.check == false;
            }
          );
          if (
            this.familyResultFilter.length == this.getAllFamilyResult.length
          ) {
            this.theadAll = true;
          }
        }

        this.$store.commit("updateAllFamilyResult", this.getAllFamilyResult);
      },
      deep: true,
    },
  },
  methods: {
    moment,
    ...mapActions([
      "updateUserItems",
      "updateFamilyResultFilter",
      "updateLastFamilyResult",
      "updatePDFData",
      "updateCustID",
      "setPageLock",
      "updateSerNo",
    ]),
    //檢查姓名
    checkInputName(item) {
      item.name = item.name.replace(
        /[<>!@#$^&,."'?%*;()+-/_{}[\]|~`=\\\s]/g,
        ""
      );
      if (this.stringBytes(item.name, false, 50) > 50) {
        item.name = item.name.substring(
          0,
          this.stringBytes(item.name, true, 50)
        );
      }
    },
    //檢查年齡
    checkInputAge(item) {
      item.age = item.age.replace(
        /[a-zA-Z<>!@#$^&,."'?%*;()+-/_{}[\]|~`=\\\s]/g,
        ""
      );
      if (this.stringBytes(item.age, false, 3) > 3) {
        item.age = item.age.substring(0, this.stringBytes(item.age, true, 3));
      }
    },
    confirmDeleteHolder() {
      if(this.confirmDeleteItem.familyrl === 0 && this.getAllFamilyResult.length === 1) {
        this.panelOpen("mvDeleteFamilyOpen");
      } else if(this.confirmDeleteItem.familyrl === 0 && this.getAllFamilyResult.length > 1) {
        this.panelClose("mvDeleteSingleOpen");
        this.panelOpen("deleteHolderMvInfoOpen");
      } else {
        this.panelClose("mvDeleteSingleOpen");
        this.panelOpen("WarningDoubleCheckModalOpen");
      }
    },
    //判斷日曆下拉選單點選是否要增加顯示長度與滾動位移
    show(emitEvent, index) {
      let realIndex = 0;
      //過濾有顯示在頁面上的家戶資料與真實index
      let family = this.getAllFamilyResult.filter((item, i) => {
        if (i < index && !item.isRemove && !item.isDelete) {
          realIndex++;
        }
        return !item.isRemove && !item.isDelete;
      });
      let familyCount = family.length;
      if (familyCount > 3) {
        for (let i = 1; i < 6; i++) {
          if (realIndex == familyCount - i) {
            this.isOpen = !emitEvent;
            this.$refs["dateDiv"].style.height = 240 - 56 * (i - 1) + "px";
            if (this.isOpen) {
              this.$nextTick(() => {
                document.documentElement.scrollTop =
                  document.documentElement.scrollHeight;
              });
            }
          }
        }
      }
    },
    resizeWindow() {
      this.innerHeight = Number(this.$refs.countHeight.clientHeight + 180);
    },
    closeMvFamilyDeleteModal(type) {
      this.panelClose("mvDeleteFamilyOpen");
      if (!this.checkDeleteFamilyModal && type == "O") {
        window.setTimeout(() => {
          this.panelOpen("mvDeleteFamilyOpen");
          this.checkDeleteFamilyModal = true;
        }, 1000);
      } else if (this.checkDeleteFamilyModal && type != "O") {
        window.setTimeout(() => {
          this.checkDeleteFamilyModal = false;
        }, 1000);
      } else if (this.checkDeleteFamilyModal && type == "O") {
        this.deleteFamilyM();
      } else {
        this.checkDeleteFamilyModal = false;
      }
    },
    checkSingleDelete(item) {
      this.confirmDeleteItem = item;
      this.panelOpen("mvDeleteSingleOpen");
    },
    closeMvSingleDeleteModal(type) {
      if (type === "R") {
        this.confirmDeleteItem.isRemove = true;
      }
      if (type === "D") {
        this.confirmDeleteItem.isDelete = true;
      }
      this.panelClose("mvDeleteSingleOpen");
      this.confirmDeleteItem = {};
    },
    closeWarningDoubleCheckModal() {
      this.confirmDeleteItem.isDelete = true;
      this.panelClose("WarningDoubleCheckModalOpen");
      this.confirmDeleteItem = {};
    },
    closeDeleteHolderMvInfoModal() {
      this.confirmDeleteItem.isDelete = true;
      this.panelClose("deleteHolderMvInfoOpen");
      this.confirmDeleteItem = {};
    },
    closeMvDeleteModal() {
      this.panelClose("mvDeleteOpen");
      this.confirmDeleteNameList = [];
    },
    closeModal() {
      this.panelClose("mvInfoOpen");
      if (this.isFirst) {
        window.setTimeout(() => (this.isFirst = false), 1000);
      }
    },
    stringBytes(c, isSub, size) {
      //計算字元長度 (字串, 是否檢查, 檢查的長度)
      let n = c.length;
      let s;
      let len = 0;
      for (let i = 0; i < n; i++) {
        s = c.charCodeAt(i);
        while (s > 0) {
          len++;
          s = s >> 8;
          if (isSub && len > size) {
            return i;
          }
        }
      }
      return len;
    },
    //編輯家戶
    changeUpdateMode() {
      if (!this.isUpdateMode) {
        this.getAllFamilyResultOriginal = JSON.parse(
          JSON.stringify(this.getAllFamilyResult)
        );
        this.getAllFamilyResultOriginal.forEach((element) => {
          if (element.birthday) {
            element["birthdayROC"] = moment(element.birthday).toDate();
          }
        });
      } else {
        this.getAllFamilyResult = JSON.parse(
          JSON.stringify(this.getAllFamilyResultOriginal)
        );
        this.getAllFamilyResult.forEach((element) => {
          if (element.birthday) {
            element["birthdayROC"] = moment(element.birthday).toDate();
          }
        });
      }
      this.isUpdateMode = !this.isUpdateMode;
    },
    //刪除客戶
    changeDeleteMode() {
      if (!this.isDeleteMode) {
        this.getAllFamilyResultOriginal = JSON.parse(
          JSON.stringify(this.getAllFamilyResult)
        );
        this.getAllFamilyResultOriginal.forEach((element) => {
          if (element.birthday) {
            element["birthdayROC"] = moment(element.birthday).toDate();
          }
        });
      } else {
        this.getAllFamilyResult = JSON.parse(
          JSON.stringify(this.getAllFamilyResultOriginal)
        );
        this.getAllFamilyResult.forEach((element) => {
          if (element.birthday) {
            element["birthdayROC"] = moment(element.birthday).toDate();
          }
        });
      }
      //重置錯誤訊息
      this.errors.items.length = 0;
      this.isDeleteMode = !this.isDeleteMode;
    },
    chkCustExist() {
      if (this.familyResultFilter.length < 1) {
        this.$toast.info({ title: "請先勾選客戶" });
        return false;
      }
      if (this.familyResultFilter.some((x) => !x.birthday || !x.sex)) {
        this.$toast.info({
          title: "缺少「性別」或「生日」無法進行保單健檢",
        });
        return false;
      }
      return true;
    },
    async checkPropertyExist() {
      const getAllFamily = this.familyResultFilter.map(
        (el) => el.csidno || el.serNo
      );
      const res = await Promise.all([
        // 健康險
        // getCustInsurance_CCIPLN4MV(this.agidno, getAllFamily),
        // 傷害險
        // getCustInsurance_CCIPLN2MV(this.agidno, getAllFamily),
        // 新種險
        // getCustInsurance_CCIPLN1MV(this.agidno, getAllFamily),
        // 車險
        // getCustInsurance_CCIPLC1MV(this.agidno, getAllFamily),
        // 火險
        // getCustInsurance_CCIPLF1MV(this.agidno, getAllFamily),
        // 其他產險
        // getOtherPropertyInsurance(this.agidno, getAllFamily),
        // 壽險
        checkPolicyExist(
          this.$store.state.userInfo.id,
          this.familyResultFilter.map((x) => x.csidno || x.serNo),
          this.familyData.csidno,
          this.isFromBank
        ),
      ]);
      if (
        !res.some(
          (x) =>
            (x.group && x.group.length) ||
            (x.body && x.body.length) ||
            // (x.data &&
            //   x.data.constructor === Object &&
            //   (x.data.othernewdataset.length ||
            //     x.data.otherfiredataset.length ||
            //     x.data.othermotordataset.length)) ||
            (x.data &&
              x.data.length &&
              x.data[0].constructor === Object &&
              x.data[0].policysum > 0) ||
            (x.body &&
              Array.isArray(x.body.policiesselfinput) &&
              x.body.policiesselfinput.length > 0) ||
            (x.body &&
              Array.isArray(x.body.policies) &&
              x.body.policies.length > 0)
        )
      ) {
        this.$toast.info({
          title: "無有效保單，無法進行保單健檢",
        });
        return false;
      }
      //20211210 新增保單超過數量提醒
      if (res[0].data[0] && res[0].data[0].policysum > 120) {
        localStorage.policyOverWarn = true;
      } else {
        localStorage.policyOverWarn = false;
      }
      return true;
    },
    setSerNo() {
      this.familyResultFilter = this.familyResultFilter.map((item) => {
        if (!item.csidno || item.csidno === "") {
          item.csidno = item.serNo;
        }
        return item;
      });
      this.lastFamilyResultFilter = this.lastFamilyResultFilter.map((item) => {
        if (!item.csidno || item.csidno === "") {
          item.csidno = item.serNo;
        }
        return item;
      });
    },
    //重新歸戶
    rePushMember() {
      if (this.familyResultFilter.length < 1) {
        this.$toast.info({ title: "請先勾選客戶" });
        return false;
      }
      if (this.familyResultFilter.length > 50) {
        this.$toast.info({ title: "家戶成員不得超過50人+" });
        return false;
      }
      //選取全部成員
      if (
        this.getAllFamilyResult &&
        this.familyResultFilter &&
        this.getAllFamilyResult.length === this.familyResultFilter.length
      ) {
        //相同> 選擇現有家戶
        this.setSerNo();
        this.updateLastFamilyResult(this.lastFamilyResultFilter);
        this.updateFamilyResultFilter(this.familyResultFilter);
        this.routerToAddToFamily();
      } else {
        //Modal 請選擇歸戶方式
        this.setSerNo();
        this.updateLastFamilyResult(this.lastFamilyResultFilter);
        this.updateFamilyResultFilter(this.familyResultFilter);
        this.panelOpen("bkmvAddFamilyOpen");
      }
    },
    routerToAddToFamily() {
      getAllHouseholderBySales(this.$store.state.userInfo.id, this.isFromBank).then((result) => {
        //若完全沒有任何家戶，保留原頁，並顯示警示訊息「沒有可以加入的家戶」
        if (
          !result.data ||
          result.data.filter((item) => item.csidno != this.familyData.csidno)
            .length === 0
        ) {
          this.$toast.info({ title: "沒有可以加入的家戶" });
          return;
        } else {
          this.$router.push({
            name: "bkAddToFamily",
            params: {
              isReAddFamily: true,
            },
          });
        }
      });
    },
    async pushPolicyHealthCheck() {
      if (!this.chkCustExist()) {
        return;
      }
      this.maskContent = "保單健檢計算中...";
      this.panelOpen("mvMaskOpen");
      /*檢核是否為公司同事及其權限是否開啟
      checkCompanyColleague(
        this.agidno,
        this.familyResultFilter.map((x) => x.csidno)
      ).then((result) => {
           if (result.body && result.body.data && result.body.data.length > 0) {
          this.companyColleagueList = result.body.data;
          this.panelClose("mvMaskOpen");
          this.panelOpen("showCheckCompanyColleague");
          return;
        }
      });*/

    
        //檢核是否有生日不一致保單
        checkBirthDayDifferent(
          this.agidno,
          this.familyResultFilter.map((x) => x.csidno || x.serNo),
          this.isFromBank
        ).then((result) => {
          if (result.body && result.body.data && result.body.data.length > 0) {
            let dup = new Set();
            this.diffBirthPolicies = result.body.data.filter(
              (item) => (dup.has(item.ceplcno) ? false : dup.add(item.ceplcno))
            );
            this.panelClose("mvMaskOpen");
            this.panelOpen("mvPolicyAndCustomerBirthCheckOpen");
          } else {
            this.panelClose("mvMaskOpen");
            this.calculatePolicyHealth();
          }
        });
    },
    //紀錄生日不一致保單LOG
    async confirmPolicyHealthCheck() {
      differBirthDayLog(this.agidno, this.diffBirthPolicies, "BNK").then((result) => {
        this.panelClose("mvPolicyAndCustomerBirthCheckOpen");
        if (result.header && result.header.status == "200") {
          this.calculatePolicyHealth();
        } else {
          this.$toast.info({ title: "系統錯誤" });
        }
      });
    },
    //開始保單健檢
    async calculatePolicyHealth() {
      this.maskContent = "保單健檢計算中...";
      this.panelOpen("mvMaskOpen");
      if (!(await this.checkPropertyExist())) {
        this.panelClose("mvMaskOpen");
        return;
      }
      this.panelClose("mvMaskOpen");
      this.updateFamilyResultFilter(this.familyResultFilter);
      localStorage.allFamily = this.familyResultFilter
        .map((x) => x.csidno || x.serNo)
        .join(",");
      this.$router.push({ name: "bkPolicyInfoPDF" });
    },
    changeInput(index, chk) {
      if (chk == "Y") {
        if (this.detectIEEdge() === 11) {
          this.getAllFamilyResult.forEach(
            (element) => (element.check = this.theadAll)
          );
        } else {
          this.getAllFamilyResult.forEach(
            (element) => (element.check = !this.theadAll)
          );
        }
      } else {
        this.theadAll = false;
      }
    },
    formatDate(preDate) {
      if (preDate) {
        let dd = moment(preDate)
          .format("YYYY-MM-DD")
          .split("-");
        dd[0] = dd[0] - 1911;
        dd = dd.join("/");

        return dd;
      } else {
        return "";
      }
    },
    detectIEEdge() {
      var ua = window.navigator.userAgent;

      var msie = ua.indexOf("MSIE ");
      if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
      }

      var trident = ua.indexOf("Trident/");
      if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf("rv:");
        return parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
      }

      var edge = ua.indexOf("Edge/");
      if (edge > 0) {
        // Edge => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf(".", edge)), 10);
      }

      // other browser
      return false;
    },
    // 新增客戶
    createCust() {
      this.panelOpen('createCustWarningOpen');
    },
    //個資法WarningModal
    proceedToCreate() {
      //20251216
      let agreeTime = window.moment().format("YYYY-MM-DD HH:mm:ss");
      this.panelClose('createCustWarningOpen');
      this.$router.push({
        name: "createBKCust2Family",
        params: {
          familyResult: this.getAllFamilyResult,
          hasSpouse: this.hasSpouse,
          pdpaAgreeTime: agreeTime 
        },
      });
    },    

    saveItems() {
      let fCheck = 0;
      let rCheck = 0;
      let sCheck = 0;
      let rsCheck = 0;
      let that = this;
      //重置錯誤訊息
      that.errors.items.length = 0;
      this.getAllFamilyResult.map((item) => {
        if (item.familyrl === 0 && !item.isDelete) {
          fCheck++;
          if (fCheck > 1) {
            for (let i = 0; i < this.getAllFamilyResult.length; i++) {
              if (this.getAllFamilyResult[i].familyrl === 0) {
                that.errors.add({
                  field: `familyrl-${i}`,
                  msg: "familyrl",
                });
              }
            }
            this.$toast.info({
              title: "僅能有一位「戶長」，請再次確認家戶成員的身份",
            });
            rCheck++;
          }
        }
        if (item.familyrl === 1) {
          sCheck++;
          if (sCheck > 1) {
            for (let i = 0; i < this.getAllFamilyResult.length; i++) {
              if (this.getAllFamilyResult[i].familyrl === 1) {
                that.errors.add({
                  field: `familyrl-${i}`,
                  msg: "familyrl",
                });
              }
            }
            if (rsCheck === 0) {
              this.$toast.info({
                title: "僅能有一位「配偶」，請再次確認家戶成員的身份",
              });
            }
            rsCheck++;
          }
        }
        if (item.isRemove || item.isDelete) {
          this.confirmDeleteNameList.push(item.name);
        }
        return item;
      });
      if (fCheck < 1 && this.getAllFamilyResult.length > this.checkDeleteCount ) {
        for (let i = 0; i < this.getAllFamilyResult.length; i++) {
          that.errors.add({
            field: `familyrl-${i}`,
            msg: "familyrl",
          });
        }
        this.$toast.info({
          title: "家中需有一位「戶長」，請再次確認",
        });
        return false;
      }
      if (rCheck > 0 || rsCheck > 0) return false;

      let _this = this;
      async function asyncStart() {
        let check = true;
        await Promise.all(
          _this.$refs.birthday.map(
            async (e) =>
              (await e.validateAll()) === false ? (check = false) : ""
          )
        );

        //檢核生日
        let birthdayErrorCount = 0;
        _this.isBirdayError = [];
        _this.getAllFamilyResult.map((item) => {
          if (
            item.birthdayROC &&
            !moment(item.birthdayROC).isSameOrBefore(moment(), "day")
          ) {
            _this.isBirdayError.push(true);
            birthdayErrorCount++;
          } else {
            _this.isBirdayError.push(false);
          }
        });
        if (birthdayErrorCount > 0) {
          _this.$toast.info({ title: "出生日期不得超過今日" });
          return false;
        }

        _this.$validator.validateAll().then((el) => {
          if (el) {
            if (_this.confirmDeleteNameList.length > 0) {
              _this.sendUpdate();
            } else {
              _this.sendUpdate();
            }
          } else {
            for (let i = 0; i < _this.errors.items.length; i++) {
              let el = _this.errors.items[i];
              if (el.field.includes("age") || !check) {
                _this.$toast.info({ title: "「生日」、「年齡」須擇一填寫" });
                break;
              } else {
                _this.$toast.info({ title: "尚有必填欄位待確認" });
                break;
              }
            }
          }
        });
      }
      asyncStart();
    },
    async sendUpdate() {
      new Promise((resolve) => {
        this.maskContent = "資料更新中，請稍候...";
        this.panelOpen("mvMaskOpen");
        resolve();
      }).then(() => {
        let familyLeader = this.getAllFamilyResult.filter((item) => {
          if (item.familyrl == 0 && !item.isDelete) {
            return true;
          } else {
            return false;
          }
        });
        //提升效能僅傳送有修改的資料
        let originalFamilyrl = this.getAllFamilyResultOriginal.filter(
          (item) => item.familyrl === 0
        );
        let newFamilyrl = this.getAllFamilyResult.filter(
          (item) => item.familyrl === 0
        );
        //判斷戶長是否有修改，若有則同步更新所有家戶資料
        let isChangeFamilyrl =
          JSON.stringify(originalFamilyrl) !== JSON.stringify(newFamilyrl);
        let changedData = this.getAllFamilyResult.filter((item, index) => {
          if (isChangeFamilyrl) {
            return true;
          }
          return (
            JSON.stringify(item) !==
            JSON.stringify(this.getAllFamilyResultOriginal[index])
          );
        });

        if (changedData.length == 0) {
          this.isUpdateMode = false;
          this.isDeleteMode = false;
          this.panelClose("mvMaskOpen");
          this.$validator.reset();
          return;
        }
        //為避免畫面切換前顯示修改過後Map的id故先複製作為參數傳遞
        let modifyData = JSON.parse(JSON.stringify(changedData));
        modifyFamilyMember_BNK(
          this.$store.state.userInfo.id,
          modifyData,
          this.checkRemoveCount,
          this.checkDeleteCount,
          false
        ).then((result) => {
          if (result.header && result.header.status == "200") {
            if(familyLeader.length > 0) {
              //為防止變更戶長為無ID成員時導致重查查無資料
              familyLeader[0].csidno = familyLeader[0].csidno
                ? familyLeader[0].csidno
                : familyLeader[0].serNo;
              this.isUpdateMode = false;
              this.isDeleteMode = false;
              this.reCoverLeaderforInit(familyLeader[0]);
              this.init();
            } else {
              this.isNoFamilyMember = true;
              this.$router.push({ name: "bkmv-allHolder" });
            }
            this.$toast.info({ title: this.isDeleteMode? `刪除成功`:`編輯成功` });
            this.panelClose("mvMaskOpen");
          } else {
            if (result.header && result.header.message) {
              let errorMessage = result.header.message;
              errorMessage = errorMessage.split("Message: ")[1].split(" ")[0];
              this.$toast.info({ title: errorMessage });
            }
            this.panelClose("mvMaskOpen");
          }
        });
        this.$validator.reset();
      });
    },
    reCoverLeaderforInit(familyLeader) {
      //更新戶長資料
      this.updateUserItems(familyLeader);
      localStorage.userItems = JSON.stringify(familyLeader);
      this.familyData = familyLeader;
    },
    selectSex(item) {
      if (item.csidno.length > 1) {
        var sexOfId = item.csidno.substr(1, 1);
        if (sexOfId.toUpperCase().match("1|8|A|C")) {
          item.sex = 1;
        } else if (sexOfId.toUpperCase().match("2|9|B|D")) {
          item.sex = 2;
        }
        item.csidno = item.csidno.toUpperCase();
      }
    },
    binarySearch(ar, el) {
      var m = 0;
      var n = ar.length - 1;
      while (m <= n) {
        var k = (n + m) >> 1;
        var cmp = this.compare_number(el, ar[k]);
        if (cmp > 0) {
          m = k + 1;
        } else if (cmp < 0) {
          n = k - 1;
        } else {
          return k;
        }
      }
      return -m - 1;
    },
    compare_number(a, b) {
      return a - b;
    },
    init() {
      //刪除保單資訊勾選人員
      localStorage.allFamily = "";
      if (!this.familyData || this.familyData.length < 1) {
        this.familyData = JSON.parse(localStorage.userItems);
      }
      /*isCustomerAgreeRemind(
        this.$store.state.userInfo.id,
        this.familyData.csidno
      ).then((result) => {
        this.mvInfoOpen = !result.data;
      });*/
      this.initFamily();
    },
    initFamily() {
      let start = moment().year();
      this.birthYearOpt = Array.apply(null, { length: 101 }).map(function(
        value,
        index
      ) {
        return start - index;
      });
      this.birthMonthOpt = Array.apply(null, Array(12)).map(function(x, i) {
        return (i + 1).toString().padStart(2, "0");
      });
      this.birthDayOpt = Array.apply(null, Array(31)).map(function(x, i) {
        return (i + 1).toString().padStart(2, "0");
      });
      this.remoteDataMessage = "資料讀取中，請稍候...";
      this.custsOfAgntIsLoading = true;
      getAllFamily(
        this.familyData.agidno,
        this.familyData.csidno,
        this.isFromBank
      ).then((result) => {
        result.data.forEach((element) => {
          element.check = this.theadAll;
          element["isDelete"] = false;//是否刪除該客戶
          element["isRemove"] = false;//是否移除該家戶成員
          if (element.birthday) {
            element["birthdayROC"] = moment(element.birthday).toDate();
          }
          if (!element.csidno.includes("~")) {
            element["isCsidno"] = true;
          } else {
            element["serNo"] = element.csidno;
            element.csidno = "";
          }
          if (element.familyrl === 1) {
            this.hasSpouse = true;
          }
        });
        this.getAllFamilyResult = result.data;
        this.remoteDataMessage =
          "無任何家戶(請先將客戶完成歸戶，才能開始使用保單健檢)";
          this.custsOfAgntIsLoading = false;
        this.$nextTick(() => {
          this.innerHeight = Number(this.$refs.countHeight.clientHeight + 180);
        });
      });
    },
    deleteFamilyM() {
      this.getAllFamilyResult = this.getAllFamilyResult.map((item) => {
        if (!item.csidno || item.csidno === "") {
          item.csidno = item.serNo;
        }
        return item;
      });
      deleteFamily(this.$store.state.userInfo.id, this.getAllFamilyResult, this.isFromBank).then(
        (result) => {
          if (result.header && result.header.status == "200") {
            this.isDeleteFamily = true;
            this.$router.push({ name: "bkmv-allHolder" });
            this.$toast.info({ title: "家戶已解散" });
          } else {
            this.$toast.info({ title: "家戶解散失敗" });
          }
        }
      );
    },
    getTime(event, item) {
      item.birthdayROC = event.date;
      if (!item.age) {
        this.$set(item, "age", "");
      }
      item.age = event.age;
    },
  },
  beforeRouteLeave(to, from, next) {
    if (from.name == "bkRelation" && (this.isUpdateMode || this.isDeleteMode) && !this.isDeleteFamily) {
      //若已刪除光所有家戶成員，則不必顯示提醒Modal
      if(!this.isNoFamilyMember) {
        this.panelOpen("leavePageWarningModalOpen");

        this.$nextTick(() => {
          this.$refs.leavePageWarningModal.$once("submit", () => {
            if (from.name == "bkRelation" && to.name == "policyInfo") {
              window.$("#familyRelationNavLink").addClass("active");
              window.$("#policyInfoNavLink").removeClass("active");
            }
            next(false);
          });
          this.$refs.leavePageWarningModal.$once("close", () => {
            next();
          });
        });
      } else {
        next();
      }
    } else {
      next();
    }
  },
  mounted() {
    this.familyRl = getFamilyrl();
    this.init();
  },
  created() {
    window.addEventListener("resize", this.resizeWindow);
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeWindow);
  },
};
</script>
<style lang="scss" scoped>
.deleted {
  opacity: 0.5;
  background: rgb(241, 241, 205);
}
.breakLine {
  word-break: break-all;
  min-width: 50px;
  max-width: 115px;
}
.requireSpan {
  width: 47px;
  height: 20px;
  font-size: 13px;
  border-radius: 4px;
  background-color: #feeedd;
}
.font-20 {
  font-size: 20px;
}
.mr-28 {
  margin-right: 28px;
}
.ml-27 {
  margin-left: 27px;
}
.mt-10 {
  margin-top: 10px;
}
.mt-21 {
  margin-top: 21px;
}
.removeButton {
  font-size: 14px;
  margin-left: -9px !important;
}
.custGreen {
  color: #048f3a;
}
.w-left {
  width: 100%;
  text-align: left;
}
.fw-600 {
  font-weight: 600;
}
.custGreenBold {
  font-weight: 600;
  color: #027a39;
}
.rounded-8 {
  border-radius: 8px;
}
.star {
  width: 13px;
  height: 18px;
  font-family: PingFangTC;
  font-size: 13px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #de4054;
}

.btn-disabled {
  color: #c2c4c7;
  border-radius: 4px;
  border: solid 1px #989ca2;
  background: #ffffff !important;
  pointer-events: none;
}
.btn-custStyle {
  padding-top: 9px !important;
  width: 120px;
  height: 40px;
}
.font-cust {
  font-family: PingFangTC;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.65;
  letter-spacing: normal;
  color: #323a45;
}
.checkDeleteContent {
  font-family: PingFangTC;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: right;
  color: #323a45;
  line-height: 50px;
  margin-right: 20px;
}
.controlAvatarLevel {
  height: 17px;
}
</style>
